import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import Accredited from '../sections/Accredited/Accredited';
import SEO from '../components/SEO';

const AccreditedPage = ({ lang = 'en' }) => {
  const BASE_URL = "https://alsaketdental.com";
  const SITE_NAME = "AlSaket Dental Clinics";
  const SITE_NAME_AR = "عيادات الساكت لطب الأسنان";

  const isArabic = lang === 'ar';
  const pageUrl = `${BASE_URL}/${lang}/accredited`;

  // JSON-LD: Accredited Page
  const accreditedPageLD = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "AlSaket Dental Clinics Certifications",
    "alternateName": "شهادات واعتمادات عيادات الساكت لطب الأسنان",
    "url": pageUrl,
    "description": "Learn about the certifications and accreditations earned by AlSaket Dental Clinics. International standards, quality certifications, and professional licenses.",
    "description_ar": "تعرف على الشهادات والاعتمادات التي حصلت عليها عيادات الساكت لطب الأسنان. معايير دولية، شهادات الجودة، والتراخيص المهنية.",
    "hasCredential": [
      {
        "@type": "EducationalOccupationalCredential",
        "name": "Medical License",
        "name_ar": "الترخيص الطبي",
        "description": "Licensed dental practice in Jordan"
      },
      {
        "@type": "EducationalOccupationalCredential", 
        "name": "International Standards",
        "name_ar": "المعايير الدولية",
        "description": "Compliance with international dental care standards"
      },
      {
        "@type": "EducationalOccupationalCredential",
        "name": "Quality Certification",
        "name_ar": "شهادة الجودة",
        "description": "Certified quality management system"
      }
    ]
  };

  return (
    <>
      <SEO
        title="Certifications & Accreditations - AlSaket Dental Clinics"
        titleAr="الشهادات والاعتمادات - عيادات الساكت"
        description="Learn about the certifications and accreditations earned by AlSaket Dental Clinics in Amman, Jordan. International standards, quality certifications, and professional licenses."
        descriptionAr="تعرف على الشهادات والاعتمادات التي حصلت عليها عيادات الساكت لطب الأسنان في عمان، الأردن. معايير دولية، شهادات الجودة، والتراخيص المهنية."
        keywords={[
          "dental clinic certifications amman", 
          "medical accreditations jordan", 
          "dental licenses amman", 
          "quality standards dental jordan",
          "international dental certifications amman",
          "professional dental credentials jordan",
          "certified dental clinic amman",
          "accredited dental practice jordan"
        ]}
        keywordsAr={[
          "شهادات عيادات الأسنان عمان", 
          "اعتمادات طبية الأردن", 
          "تراخيص طب الأسنان عمان", 
          "معايير الجودة طب الأسنان الأردن",
          "شهادات طب الأسنان الدولية عمان",
          "أوراق اعتماد طب الأسنان المهنية الأردن",
          "عيادة أسنان معتمدة عمان",
          "ممارسة طب الأسنان المعتمدة الأردن"
        ]}
        url={pageUrl}
        image={`${BASE_URL}/images/accredited-og-image.jpg`}
        siteName={SITE_NAME}
        siteNameAr={SITE_NAME_AR}
        structuredData={[accreditedPageLD]}
        lang={isArabic ? 'ar' : 'en'}
      />
      
      <Navbar />
      <Accredited />
      <Footer />
    </>
  );
};

export default AccreditedPage;
